import { Popover, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { CompactPicker } from 'react-color';
import { useDispatch } from 'react-redux';
import { setIgnoreKeyCodeEvent } from '../../../../redux/board/reducer';
import { styles } from '../styles';
import DropdownEditData from './DropdownEditData';
import Input from './Input';

const DraggableRow = ({ index, row, editorInfo, editTableData, handleEditTableData, onUpdate }) => {
  const classes = styles();

  const dispatch = useDispatch();

  const [hex, setHex] = useState(null);
  const [isOpenDropdown, setIsOpenDropDown] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleOpenChange = (open) => {
    setIsOpenDropDown(open);
  };

  const colorChange = ({ hex }) => {
    setHex(hex);
  };

  useEffect(() => {
    if (hex) {
      const { categories, series } = JSON.parse(editorInfo.data);
      const data = {
        categories: categories,
        series: [],
      };
      data.series = series.map((item, idx) => (idx === index ? { ...item, color: hex } : item));
      onUpdate(data);
    }
  }, [hex]);

  useEffect(() => {
    dispatch(setIgnoreKeyCodeEvent(visible));
  }, [visible]);

  return (
    <Draggable draggableId={index.toString()} index={index}>
      {(provided) => (
        <tr
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            ...provided.draggableProps.style,
            backgroundColor: '#fff',
          }}
        >
          <th className={`${classes.header} ${classes.rowHeader}`}>
            <Tooltip title={'Change color'}>
              <Popover
                zIndex={1071}
                content={<CompactPicker onChangeComplete={colorChange} color={row.color} />}
                trigger="click"
                onOpenChange={(e) => setVisible(e)}
              >
                <div className={classes.colorPicker} style={{ backgroundColor: row.color || '#fff' }}></div>
              </Popover>
            </Tooltip>
            {editTableData.isRowHead && editTableData.index === index ? (
              <Input data={row.name} editorInfo={editorInfo} editTableData={editTableData} onUpdate={onUpdate} />
            ) : (
              <>
                <span
                  className={`${isOpenDropdown && classes.dropdownOpen}`}
                  onClick={() => handleEditTableData(false, true, index)}
                >
                  {row.name}
                </span>
                <DropdownEditData
                  index={index}
                  type="row"
                  editorInfo={editorInfo}
                  onUpdate={onUpdate}
                  handleOpenChange={handleOpenChange}
                />
              </>
            )}
          </th>
          {row.data.map((r, i) => (
            <td key={i} className={classes.row}>
              {!editTableData.isRowHead &&
              !editTableData.isColHead &&
              editTableData.index === index &&
              editTableData.row === i ? (
                <Input data={r} editorInfo={editorInfo} editTableData={editTableData} onUpdate={onUpdate} />
              ) : (
                <span onClick={() => handleEditTableData(false, false, index, i)}>{r}</span>
              )}
            </td>
          ))}
        </tr>
      )}
    </Draggable>
  );
};

export default DraggableRow;
